import { getRequestTransportErrorMessage } from '#/utils/requestError';

export function getPurchaseOrderApiErrorMessage(error, fallback = '操作失敗') {
  const transportMessage = getRequestTransportErrorMessage(error);
  if (transportMessage) {
    return transportMessage;
  }

  const data = error?.response?.data;
  const code = data?.code;

  if (code === 'RESOURCE_VERSION_CONFLICT') {
    return data?.message || '資料已被他人修改，請重新載入後再試';
  }

  if (code === 'UPDATED_AT_REQUIRED') {
    return data?.message || '缺少更新時間，請重新載入後再試';
  }

  if (code === 'PURCHASE_ORDER_AMENDMENT_QTY_BELOW_RECEIPT') {
    return data?.message || '異動後數量不可低於已入庫／在途進貨量';
  }

  if (code === 'PURCHASE_ORDER_NOT_FOUND' || code === 'RESOURCE_NOT_FOUND') {
    return data?.message || '找不到物料採購單資料';
  }

  if (data?.message) {
    return data.message;
  }

  if (code) {
    return `${fallback}（${code}）`;
  }

  return fallback;
}

export function isPurchaseOrderVersionConflict(error) {
  return error?.response?.data?.code === 'RESOURCE_VERSION_CONFLICT';
}
